import React from 'react';

export const DashboardContainer = ({ children, className }) => {
  return <div className={`w-full ${className}`}>{children}</div>;
};
